import {
  isServer,
  QueryClient,
  QueryKey,
  UseQueryOptions,
} from '@tanstack/react-query';

export type AdditionalQueryOptions<
  TData,
  TQueryKey extends QueryKey = QueryKey,
> = Omit<
  UseQueryOptions<TData, Error, TData, TQueryKey>,
  'queryKey' | 'queryFn'
>;

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
      },
    },
  });
}

let browserQueryClient: QueryClient | undefined;

export function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  }
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}
